var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 191,
    viewBox: "0 0 120 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.467,
    height: 6.60908,
    rx: 3.30454,
    transform: "matrix(-0.601033 -0.799224 0.914216 -0.405227 20.7158 39.9995)",
    fill: "url(#paint0_linear_209_1046)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3235,
    y: 31.8086,
    width: 31.8084,
    height: 6.97684,
    rx: 3.48842,
    transform: "rotate(-90 55.3235 31.8086)",
    fill: "url(#paint1_linear_209_1046)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34.8564,
    height: 6.5509,
    rx: 3.27545,
    transform: "matrix(0.638227 -0.769848 0.898472 0.43903 91.3235 36.814)",
    fill: "url(#paint2_linear_209_1046)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34.4666,
    height: 6.60906,
    rx: 3.30453,
    transform: "matrix(-0.601039 0.79922 0.914219 0.405221 20.7158 151)",
    fill: "url(#paint3_linear_209_1046)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 31.8078,
    height: 6.97684,
    rx: 3.48842,
    transform: "matrix(0 1 1 0 55.3235 159.191)",
    fill: "url(#paint4_linear_209_1046)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 34.8561,
    height: 6.55088,
    rx: 3.27544,
    transform: "matrix(0.638233 0.769843 0.898475 -0.439024 91.3235 154.186)",
    fill: "url(#paint5_linear_209_1046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_1046",
    x1: 34.467,
    y1: 0,
    x2: 32.0223,
    y2: 12.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_1046",
    x1: 87.1318,
    y1: 31.8086,
    x2: 84.2117,
    y2: 45.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_1046",
    x1: 34.8564,
    y1: 0,
    x2: 32.4781,
    y2: 12.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_1046",
    x1: 34.4666,
    y1: 0,
    x2: 32.0219,
    y2: 12.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_209_1046",
    x1: 31.8078,
    y1: 0,
    x2: 28.8877,
    y2: 13.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_209_1046",
    x1: 34.8561,
    y1: 0,
    x2: 32.4777,
    y2: 12.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57007B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup40);
export default __webpack_public_path__ + "static/media/Group_40.bf0885acb2cfecea536f37c2c42be00b.svg";
export { ForwardRef as ReactComponent };